<template>
  <v-container fluid>

    <v-row dense class="pa-1" align="stretch" v-if="canSeeNewPatientCenterView()">
      <v-col cols="12" md="12">
        <v-card class="pa-1" outlined>
          <NewPatientCenter />
        </v-card>
      </v-col>
    </v-row>

    <v-row dense class="pa-1" align="stretch" v-if="canSeeCenterInfoView()">
      <v-col cols="12" md="6">
        <v-card class="pa-1" outlined>
          <CenterInfoBarChart />
        </v-card>
      </v-col>

      <v-col cols="12" md="6" class="d-flex">
        <v-card class="pa-1" outlined>
          <CenterInfo />
        </v-card>
      </v-col>
    </v-row>

    <v-row dense class="pa-1" align="stretch" v-if="canSeeCenterInfoView()">
      <v-col cols="12" md="6">
        <v-card class="pa-1" outlined>
          <PatientCenterInfoBarChart />
        </v-card>
      </v-col>

      <v-col cols="12" md="6" class="d-flex">
        <v-card class="pa-1" outlined>
          <PatientCenterInfo />
        </v-card>
      </v-col>
    </v-row>

    <v-row dense class="pa-1" align="stretch" v-if="canSeePatientChartView()">
      <v-col cols="12" md="6">
        <v-card class="pa-1" outlined>
          <PatientChart />
        </v-card>
      </v-col>

      <v-col cols="12" md="6" class="d-flex" v-if="canSeePatientGenderPercentagetView()">
        <v-card class="pa-1" outlined>
          <PatientGenderPercentage />
        </v-card>
      </v-col>
    </v-row>

    <v-row dense class="pa-1" align="stretch" v-if="canSeeAgeAtFirstDiagnosisChartView()">
      <v-col cols="12" md="12">
        <v-card class="pa-1" outlined>
          <AgeAtFirstDiagnosisCount />
        </v-card>
      </v-col>
    </v-row>

    <v-row dense class="pa-1" align="stretch" v-if="canSeeAgeAtFirstDiagnosisChartView()">
      <v-col cols="12" md="12">
        <v-card class="pa-1" outlined>
          <AgeAtFirstDiagnosisChart />
        </v-card>
      </v-col>
    </v-row>

    <v-row dense class="pa-1" align="stretch" v-if="canSeeAgeAtFirstDiagnosisChartView()">
      <v-col cols="12" md="12">
        <v-card class="pa-1" outlined>
          <AgeAtFirstDiagnosisPercentageChart />
        </v-card>
      </v-col>
    </v-row>

    <v-row dense class="pa-1" align="stretch" v-if="canSeeCurrentAgeCountView()">
      <v-col cols="12" md="12">
        <v-card class="pa-1" outlined>
          <CurrentAgeCount />
        </v-card>
      </v-col>
    </v-row>

    <v-row dense class="pa-1" align="stretch" v-if="canSeeCurrentAgeCountView()">
      <v-col cols="12" md="12">
        <v-card class="pa-1" outlined>
          <CurrentAgeChart />
        </v-card>
      </v-col>
    </v-row>

    <v-row dense class="pa-1" align="stretch" v-if="canSeeCurrentAgeCountView()">
      <v-col cols="12" md="12">
        <v-card class="pa-1" outlined>
          <CurrentAgePercentageChart />
        </v-card>
      </v-col>
    </v-row>

    <v-row dense class="pa-1" align="stretch" v-if="canSeeVisitYearDurationDescriptiveStatisticsView()">
      <v-col cols="12" md="12">
        <v-card class="pa-1" outlined>
          <VisitYearDurationDescriptiveStatistics />
        </v-card>
      </v-col>
    </v-row>

    <v-row dense class="pa-1" align="stretch" v-if="canSeeTimeSinceLastVisitView()">
      <v-col cols="12" md="6" v-if="canSeeTimeSinceLastVisitView()">
        <v-card class="pa-1" outlined>
          <TimeSinceLastVisit />
        </v-card>
      </v-col>

      <v-col cols="12" md="6" v-if="canSeeRatingView()">
        <v-card class="pa-1" outlined>
          <Rating />
        </v-card>
      </v-col>
    </v-row>

    <v-row dense class="pa-1" align="stretch" v-if="canSeeComorbiditiesView()">
      <v-col cols="12" md="12">
        <v-card class="pa-1" outlined>
          <comorbidities />
          <v-divider class="my-1" />
          <comorbiditiesTableOverview />
          <comorbiditiesTable />
        </v-card>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
import PatientChart from "../components/dataVisualization/dashboardDGE/PatientChart.vue";
import PatientVisit from "../components/dataVisualization/dashboardDGE/PatientVisit.vue";
import NewPatientCenter from "../components/dataVisualization/dashboardDGE/NewPatientCenter.vue";
import TherapyInstrument from "../components/dataVisualization/dashboardDGE/TherapyInstrument.vue";
import VisitInstitute from "../components/dataVisualization/dashboardDGE/VisitInstitute.vue";
import Rating from "../components/dataVisualization/dashboardDGE/Rating.vue";
import Comorbidities from "../components/dataVisualization/dashboardDGE/Comorbidities.vue";
import PatientCenter from "@/components/dataVisualization/dashboardDGE/PatientCenter.vue";
import PatientGenderPercentage from "@/components/dataVisualization/dashboardDGE/PatientGenderPercentage.vue";
import AgeAtFirstDiagnosisCount from "@/components/dataVisualization/dashboardDGE/AgeAtFirstDiagnosisCount.vue";
import CurrentAgeCount from "@/components/dataVisualization/dashboardDGE/CurrentAgeCount.vue";
import CurrentAgePercentage from "@/components/dataVisualization/dashboardDGE/CurrentAgePercentage.vue";
import VisitYearDurationDescriptiveStatistics from "@/components/dataVisualization/dashboardDGE/VisitYearDurationDescriptiveStatistics.vue";
import TimeSinceLastVisit from "@/components/dataVisualization/dashboardDGE/TimeSinceLastVisit.vue";
import TimeSinceLastVisitPivot from "@/components/dataVisualization/dashboardDGE/TimeSinceLastVisitPivot.vue";
import CenterInfo from "@/components/dataVisualization/dashboardDGE/CenterInfo.vue";
import CenterInfoBarChart from "@/components/dataVisualization/dashboardDGE/CenterInfoBarChart.vue";
import AgeAtFirstDiagnosisChart from "@/components/dataVisualization/dashboardDGE/AgeAtFirstDiagnosisChart.vue";
import AgeAtFirstDiagnosisPercentageChart from "@/components/dataVisualization/dashboardDGE/AgeAtFirstDiagnosisPercentageChart.vue";
import CurrentAgeChart from "@/components/dataVisualization/dashboardDGE/CurrentAgeChart.vue";
import CurrentAgePercentageChart from "@/components/dataVisualization/dashboardDGE/CurrentAgePercentageChart.vue";
import ComorbiditiesTable from "@/components/dataVisualization/dashboardDGE/comorbiditiesTable.vue";
import ComorbiditiesTableOverview from "@/components/dataVisualization/dashboardDGE/comorbiditiesTableOverview.vue";
import {
  canSeeAgeAtFirstDiagnosisChartView,
  canSeeCenterInfoView,
  canSeeComorbiditiesView,
  canSeeCurrentAgeCountView,
  canSeeNewPatientCenterView,
  canSeePatientChartView,
  canSeePatientGenderPercentagetView,
  canSeeRatingView,
  canSeeTimeSinceLastVisitView,
  canSeeVisitYearDurationDescriptiveStatisticsView
} from "@/auxillary/customPermissions";
import PatientCenterInfo from "@/components/dataVisualization/dashboardDGE/PatientCenterInfo.vue";
import PatientCenterInfoBarChart from "@/components/dataVisualization/dashboardDGE/PatientCenterInfoBarChart.vue";

export default {
  methods: {
    canSeeComorbiditiesView,
    canSeeRatingView,
    canSeeTimeSinceLastVisitView,
    canSeeAgeAtFirstDiagnosisChartView,
    canSeeCenterInfoView,
    canSeeNewPatientCenterView,
    canSeePatientGenderPercentagetView,
    canSeeCurrentAgeCountView,
    canSeePatientChartView,
    canSeeVisitYearDurationDescriptiveStatisticsView
  },
  components: {
    PatientCenterInfoBarChart,
    PatientCenterInfo,
    ComorbiditiesTableOverview,
    ComorbiditiesTable,
    CurrentAgePercentageChart,
    CurrentAgeChart,
    AgeAtFirstDiagnosisPercentageChart,
    AgeAtFirstDiagnosisChart,
    CenterInfoBarChart,
    CenterInfo,
    TimeSinceLastVisitPivot,
    TimeSinceLastVisit,
    VisitYearDurationDescriptiveStatistics,
    CurrentAgePercentage,
    CurrentAgeCount,
    AgeAtFirstDiagnosisCount,
    PatientGenderPercentage,
    PatientCenter,
    PatientChart,
    PatientVisit,
    NewPatientCenter,
    TherapyInstrument,
    VisitInstitute,
    Rating,
    Comorbidities
  }
};
</script>

<style scoped>
.v-application {
  padding: 0 !important;
  margin: 0 !important;
}

.v-container {
  max-width: 100% !important;
}

.v-card {
  font-size: 0.75rem;
}

.v-data-table {
  font-size: 0.7rem;
}

canvas,
.chart-container {
  max-height: 250px !important;
}

.v-divider {
  margin-top: 4px !important;
  margin-bottom: 4px !important;
}
</style>
